import React, { FC } from 'react';
import { Kfh_YearStatisticsType } from '../../types/graphqlTypes';
import { Chart } from './Chart';
import { colors } from '../../styles/tokens';
import { DataVisualPanel } from './DataVisualPanel';

interface AverageSoldPricesHistoricalProps {
  locationName: string;
  yearlyAverage: Kfh_YearStatisticsType;
}

export const AverageSoldPricesHistorical: FC<AverageSoldPricesHistoricalProps> = ({
  locationName,
  yearlyAverage,
  ...rest
}) => {
  const historicalChartDataset = yearlyAverage;
  const historicalLabels = historicalChartDataset?.map((stat) => stat.year);
  const historicalAveragePrices = historicalChartDataset?.map((stat) =>
    stat.average === null ? undefined : stat.average
  );
  const historicalAverageHousePrices = historicalChartDataset?.map((stat) =>
    stat.houseAverage === null ? undefined : stat.houseAverage
  );
  const historicalAverageFlatPrices = historicalChartDataset?.map((stat) =>
    stat.flatAverage === null ? undefined : stat.flatAverage
  );

  const skipped = (ctx, value) => (ctx.p0.skip || ctx.p1.skip ? value : undefined);

  const datasetOptions = {
    fill: false,
    lineTension: 0.3,
    segment: {
      borderColor: (ctx) => skipped(ctx, 'rgb(0,0,0,0.2)'),
      borderDash: (ctx) => skipped(ctx, [6, 6]),
    },
    spanGaps: true,
  };

  const chartData = {
    labels: historicalLabels,
    datasets: [
      {
        label: 'All properties',
        data: historicalAveragePrices,
        backgroundColor: colors.brand.default,
        borderColor: colors.brand.default,
        ...datasetOptions,
      },
      {
        label: 'Houses',
        type: 'bar',
        data: historicalAverageHousePrices,
        backgroundColor: colors.accent2.default,
        borderColor: colors.accent2.default,
        ...datasetOptions,
      },
      {
        label: 'Flats',
        type: 'bar',
        data: historicalAverageFlatPrices,
        backgroundColor: colors.accent1.default,
        borderColor: colors.accent1.default,
        ...datasetOptions,
      },
    ],
  };

  return (
    <>
      {yearlyAverage && (
        <DataVisualPanel
          heading={`Historical sold prices in ${locationName} from ${yearlyAverage[0].year} - ${
            yearlyAverage.slice(-1)[0].year
          }`}
          source="Land Registry"
          {...rest}
        >
          <Chart chartData={chartData} />
        </DataVisualPanel>
      )}
    </>
  );
};
